import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { NotificationService } from 'src/app/config/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent implements OnInit {

  forgotPasswordForm!: FormGroup;
  user: any;

  constructor(private authService: AuthService,private toastr: NotificationService,private router: Router,) { }

  ngOnInit(): void {
    this.forgotPasswordForm = new FormGroup({
          "vEmail": new FormControl('', { validators: [Validators.required] })
        });
  }

  forgotPasswordHandle(){
    this.user = {
      vEmail: this.forgotPasswordForm.value.vEmail
    };

    this.authService.forgotPassword(this.user).subscribe((result) => {
      if (result['code'] == 200) {
        this.toastr.showSuccess(result['message'], '');
        console.log(result,'diweundi')
        const tokenID = result['data'].link;
        window.location.href = tokenID;
        // this.router.navigate([`reset-password?token=${tokenID}`]);
      }
    })
  }

}
